export function initRecaptcha() {
	let script = document.createElement('script');
	script.src = '/static/recaptcha-v3.js';
	document.body.appendChild(script);
}



// WEBPACK FOOTER //
// ../source/common/recaptcha-v3/init-recaptcha-v3.js